import { inject, Injectable } from "@angular/core";

import { Observable, tap } from "rxjs";

import { PilotDataResponse, RequestState } from "@shared/models";
import { PilotDataApiService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class PvdsService {
  pilotDataApiService = inject(PilotDataApiService);

  pilotData: PilotDataResponse = {} as PilotDataResponse;
  getPvds(): Observable<RequestState<PilotDataResponse>> {
    return this.pilotDataApiService.getPilotData(false).pipe(
      tap((response) => {
        if (response.response) {
          this.pilotData = response.response;
        }
      })
    );
  }

  savePvds(pvdValue: number): Observable<RequestState<PilotDataResponse>> {
    return this.pilotDataApiService.updatePilotData(this.pilotData, pvdValue);
  }
}
